import { useState } from "react";
import { catalogGroups, cateTabs } from "../../../mocks/portalData";

export default function Catalog() {
  const [active, setActive] = useState(0);
  const group = catalogGroups[active];

  return (
    <section id="catalog" className="mx-auto w-full max-w-[1320px] px-4 py-10 md:px-6 md:py-14">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="flex items-center gap-2">
            <span className="h-4 w-1 rounded-full bg-accent-500"></span>
            <h3 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">分类图鉴</h3>
          </div>
          <p className="mt-2 text-sm text-foreground-600">
            像翻手册一样按索引吃瓜：人物、事件、类型三本分册，每一条都配齐前因后果。
          </p>
        </div>
        <div className="flex w-fit gap-1 rounded-full border border-background-200 bg-background-100 p-1">
          {cateTabs.map((tab, idx) => (
            <button
              key={tab.label}
              type="button"
              onClick={() => setActive(idx)}
              className={
                "flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-bold transition-colors " +
                (active === idx ? "bg-foreground-950 text-background-50" : "text-foreground-600 hover:text-foreground-950")
              }
            >
              <i className={tab.icon + " text-sm"}></i>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-3 flex items-center gap-2">
        <i className="ri-archive-line text-sm text-foreground-400"></i>
        <p className="text-xs text-foreground-500">
          「{group.name}」分册 · {group.desc}
        </p>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {group.items.map((item, idx) => (
          <a
            href="#flow"
            key={idx}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-background-300"
          >
            <div className="relative h-48 w-full overflow-hidden md:h-52">
              <img
                src={item.cover}
                alt={item.title}
                title={`${item.mark} 52黑料图鉴`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-md bg-background-50/90 px-2 py-0.5 text-xs font-bold text-foreground-800 backdrop-blur">
                {item.mark}
              </span>
              <span className="absolute right-3 top-3 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-bold text-background-50">
                <i className="ri-chat-3-line text-xs"></i>
                {item.comments}
              </span>
            </div>
            <div className="flex flex-1 flex-col gap-2 p-4">
              <h4 className="font-heading text-base font-black leading-snug text-foreground-950 group-hover:text-primary-600">
                {item.title}
              </h4>
              <p className="text-sm leading-relaxed text-foreground-600">{item.intro}</p>
              <div className="mt-auto flex flex-wrap gap-1.5 pt-2">
                {item.tags.map((tag) => (
                  <span key={tag} className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-800">
                    #{tag}
                  </span>
                ))}
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}